var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isRealTimeDataAvailable)?_c('div',{staticClass:"departure",class:{ 'barrier-free': _vm.departure.isBarrierFree }},[_vm._v(" "+_vm._s(_vm.departure.realTimeCountDown)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }